import { render, staticRenderFns } from "./BrandManage.vue?vue&type=template&id=5591b959&"
import script from "./BrandManage.vue?vue&type=script&lang=js&"
export * from "./BrandManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports